import { EntitySwitch, isComponentType } from '@backstage/plugin-catalog';
import { DefaultEntityPage } from '../default';
import { componentEntityPage } from './componentPage';
import { EnvironmentEntityPage } from './environment';

// service and infrastructure render the same page; a website has no catalog APIs.
const ApiComponentPage = componentEntityPage({ withApis: true });
const WebsitePage = componentEntityPage({ withApis: false });

export const ComponentEntityPage = (
  <EntitySwitch>
    <EntitySwitch.Case if={isComponentType('service')}>{ApiComponentPage}</EntitySwitch.Case>

    <EntitySwitch.Case if={isComponentType('website')}>{WebsitePage}</EntitySwitch.Case>

    <EntitySwitch.Case if={isComponentType('infrastructure')}>{ApiComponentPage}</EntitySwitch.Case>

    <EntitySwitch.Case if={isComponentType('environment')}>
      <EnvironmentEntityPage />
    </EntitySwitch.Case>

    <EntitySwitch.Case>{DefaultEntityPage}</EntitySwitch.Case>
  </EntitySwitch>
);
